/**
 * Opens Osano's "Do not sell or share my personal information" modal.
 *
 * osano.js exposes `window.Osano.cm` only after it loads (gated by the `osano`
 * experiment alongside <OsanoScriptTag />). The optional chaining makes this a no-op when
 * Osano is not present, so a stray click can never throw. Callers should still only render the
 * triggering link where Osano is loaded; see the footer's `osanoEnabled` gating.
 *
 * The `cm.showDoNotSell` type is declared on the Window interface in OsanoConsentListener.tsx.
 * https://developers.osano.com/cmp/javascript-api/developer-documentation-consent-javascript-api
 */
export function showDoNotSell(): void {
    window.Osano?.cm?.showDoNotSell();
}
